import React, { useEffect, useState } from "react";
import FormulaHeader from "./FormulaHeader";

const Formula = () => {
  return (
    <div>
      <div className="container">
        <div className="card mt-2">
          <div className="card-body">
            <h2 className="text-center font-weight-bold text-muted">
              <img src="https://img.icons8.com/color/48/000000/racing-lap.png" />
              Formula Racing
            </h2>
            <FormulaHeader />
          </div>
          <h2 className="text-center">All Matches</h2>
          <div className="card-body"></div>
        </div>
      </div>
    </div>
  );
};

export default Formula;
